import LiveButtons from "./LiveButtons";
import LiveMenuDesktop from "./LiveMenuDesktop";
import LiveStatussesFilters from "./LiveStatussesFilters";

const LiveMenu = () => {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between rounded-[0.4rem] border border-grey-blue-light bg-white p-6">
      <LiveButtons />
      <LiveStatussesFilters />
      <LiveMenuDesktop />
    </div>
  );
};

export default LiveMenu;
